import { render } from "./TestimonialView.vue?vue&type=template&id=53e7043c"
import script from "./TestimonialView.vue?vue&type=script&lang=js"
export * from "./TestimonialView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__